module.exports = "/assets/data/e3f6b3454dfd406ad7e1e40fbae6abdd-CR8.data.json";